export const GOALS_URL_PARAMS = new Map([
  [
    'fatigue', {
      goalName: 'Fatigue',
      score: '30',
      goalId: 0,
      starterTestId: 68
    }
  ],
  [
    'weight-management', {
      goalName: 'Weight Management',
      score: '40',
      goalId: 2,
      starterTestId: 1
    }
  ],
  [
    'heart-health', {
      goalName: 'Heart Health',
      score: '40',
      goalId: 13,
      starterTestId: 1
    }
  ],
  [
    'anxiety-depression', {
      goalName: 'Anxiety & Depression',
      score: '10',
      goalId: 8,
      starterTestId: 53
    }
  ],
  [
    'brain-fog', {
      goalName: 'Brain Fog',
      score: '30',
      goalId: 1,
      starterTestId: 68
    }
  ],
  [
    'libido', {
      goalName: 'Libido',
      score: '50',
      goalId: 8,
      starterTestId: 204
    }
  ],
  [
    'womens-health', {
      goalName: 'Women\'s Hormones',
      score: '50',
      goalId: 22,
      starterTestId: 207
    }
  ],
  [
    'longevity', {
      goalName: 'Longevity',
      score: '40',
      goalId: 27,
      starterTestId: 65
    }
  ],
  [
    'bloating', {
      goalName: 'Bloating',
      score: '40',
      goalId: 3,
      starterTestId: 65
    }
  ],
  [
    'hormonal-imbalances', {
      goalName: 'Hormonal Imbalances',
      goalId: 22,
      score: '50',
      starterTestId: 117,
    }
  ],
  [
    'menopause', {
      goalName: 'Menopause',
      score: '50',
      goalId: 31,
      starterTestId: 117
    }
  ],
  [
    'digestive-issues', {
      goalName: 'Digestive Issues',
      score: '40',
      goalId: 4,
      starterTestId: 65,
    }
  ]
])
